// extracted by mini-css-extract-plugin
module.exports = {"outer":"_39Ib5","heading":"_3xBcG","subHeading":"_1T7V9"};